var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "drag_group" },
    [
      _c(
        "draggable",
        {
          attrs: {
            group: _vm.dragType,
            animation: "100",
            filter: ".forbid",
            dragClass: "dragClass",
            ghostClass: "ghostClass",
            chosenClass: "chosenClass",
            move: _vm.onMove
          },
          on: { end: _vm.onEnd, start: _vm.onStart },
          model: {
            value: _vm.newAppfiles,
            callback: function($$v) {
              _vm.newAppfiles = $$v
            },
            expression: "newAppfiles"
          }
        },
        [
          _c(
            "transition-group",
            { attrs: { tag: "span", id: _vm.indexSite + "-" + _vm.indexRoom } },
            _vm._l(_vm.newAppfiles, function(appfileItem, appfileIndex) {
              return _c(
                "div",
                {
                  key: _vm.dragType + appfileItem.specialAppfile,
                  staticClass: "appfile_info",
                  class: {
                    greenStyle: appfileItem.applicationanswer === "B",
                    originStyle: appfileItem.applicationanswer === "C",
                    noShow: _vm.isNoshow(appfileItem)
                  }
                },
                [
                  _c("i", { staticClass: "kdfont kdfont-wode3" }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "ellipsis",
                      staticStyle: { width: "48px" },
                      attrs: { title: appfileItem.appfileName }
                    },
                    [_vm._v(_vm._s(appfileItem.appfileName))]
                  ),
                  _vm._v(" "),
                  appfileItem.hasSendMsg
                    ? _c("i", { staticClass: "kdfont kdfont-goutong" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "bottom",
                        width: "300",
                        "popper-class": "set_pop"
                      },
                      on: { "after-leave": _vm.hideSetPop },
                      model: {
                        value:
                          _vm.setPops[
                            _vm.dragType + appfileItem.specialAppfile
                          ],
                        callback: function($$v) {
                          _vm.$set(
                            _vm.setPops,
                            _vm.dragType + appfileItem.specialAppfile,
                            $$v
                          )
                        },
                        expression:
                          "setPops[dragType + appfileItem.specialAppfile]"
                      }
                    },
                    [
                      _c("div", { staticClass: "pop_info" }, [
                        _c("img", {
                          attrs: { src: _vm.defaultHeadImg, alt: "" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "basedata" }, [
                          _c("span", { staticClass: "name" }, [
                            _vm._v(_vm._s(appfileItem.appfileName))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "phone" }, [
                            _vm._v(_vm._s(appfileItem.appfilePhone))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pop_move" },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                                "flex-wrap": "nowrap"
                              }
                            },
                            [_vm._v("移动至")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticClass: "select_date",
                              attrs: {
                                placeholder: "请选择",
                                "popper-class": "pop_select"
                              },
                              on: {
                                change: function($event) {
                                  _vm.selectSiteIndex = 0
                                }
                              },
                              model: {
                                value: _vm.selectDateIndex,
                                callback: function($$v) {
                                  _vm.selectDateIndex = $$v
                                },
                                expression: "selectDateIndex"
                              }
                            },
                            _vm._l(
                              _vm.cusParam_configData.specialArrTimeDateList,
                              function(itemDate, indexDate) {
                                return _c("el-option", {
                                  key: itemDate,
                                  attrs: {
                                    label: _vm.dateFormat("MM月dd号", itemDate),
                                    value: indexDate
                                  }
                                })
                              }
                            ),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticClass: "select_site",
                              attrs: {
                                placeholder: "请选择",
                                "popper-class": "pop_select"
                              },
                              model: {
                                value: _vm.selectSiteIndex,
                                callback: function($$v) {
                                  _vm.selectSiteIndex = $$v
                                },
                                expression: "selectSiteIndex"
                              }
                            },
                            _vm._l(
                              _vm.cusParam_configData
                                .specialArrTimeRangeListEntities[
                                _vm.selectDateIndex
                              ].specialArrTimeRoomListEntities,
                              function(itemSite, indexSite) {
                                return _c("el-option", {
                                  key: itemSite.specialArrTimeRange,
                                  attrs: {
                                    label: itemSite.specialArrTimeRange,
                                    value: indexSite
                                  }
                                })
                              }
                            ),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "pop_divider" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "pop_join" }, [
                        _c(
                          "div",
                          {
                            staticClass: "join_item",
                            on: {
                              click: function($event) {
                                _vm.joinState = true
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "kdfont",
                              class: [
                                _vm.joinState === true
                                  ? "kdfont-liebiaodanxuankuangxuanzhong"
                                  : "kdfont-danxuankuang-weixuan"
                              ]
                            }),
                            _vm._v("参加\n            ")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "join_item",
                            on: {
                              click: function($event) {
                                _vm.joinState = false
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "kdfont",
                              class: [
                                _vm.joinState === false
                                  ? "kdfont-liebiaodanxuankuangxuanzhong"
                                  : "kdfont-danxuankuang-weixuan"
                              ]
                            }),
                            _vm._v("不参加\n            ")
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.joinState === false,
                              expression: "joinState === false"
                            }
                          ],
                          staticClass: "pop_refuse"
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "select_refuse",
                              class: {
                                selectRedTip:
                                  _vm.verifyStatus &&
                                  _vm.selectRejectIds.length === 0
                              },
                              attrs: {
                                multiple: "",
                                placeholder: "请选择拒绝原因",
                                "popper-class": "pop_select"
                              },
                              on: {
                                change: function($event) {
                                  _vm.verifyStatus = false
                                }
                              },
                              model: {
                                value: _vm.selectRejectIds,
                                callback: function($$v) {
                                  _vm.selectRejectIds = $$v
                                },
                                expression: "selectRejectIds"
                              }
                            },
                            [
                              _vm._l(_vm.cusParam_rejectRsn, function(
                                itemReject
                              ) {
                                return _c(
                                  "el-option",
                                  {
                                    key: itemReject.key,
                                    attrs: {
                                      label: itemReject.value,
                                      value: itemReject.key
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "kdfont",
                                      class: [
                                        _vm.selectRejectIds.includes(
                                          itemReject.key
                                        )
                                          ? "kdfont-fuxuankuangxuanzhong_fang"
                                          : "kdfont-fuxuankuangweixuanzhong_fang"
                                      ]
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticStyle: { "margin-left": "3px" } },
                                      [_vm._v(_vm._s(itemReject.value))]
                                    )
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "el-option",
                                {
                                  key: "other",
                                  attrs: { label: "其他", value: "other" }
                                },
                                [
                                  _c("i", {
                                    staticClass: "kdfont",
                                    class: [
                                      _vm.selectRejectIds.includes("other")
                                        ? "kdfont-fuxuankuangxuanzhong_fang"
                                        : "kdfont-fuxuankuangweixuanzhong_fang"
                                    ]
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-left": "3px" } },
                                    [_vm._v("其他")]
                                  )
                                ]
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.verifyStatus && _vm.selectRejectIds.length === 0
                            ? _c("div", { staticClass: "null_value_tip" }, [
                                _vm._v("值不能为空")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.selectRejectIds.includes("other"),
                                expression: "selectRejectIds.includes('other')"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectRejectText,
                                expression: "selectRejectText"
                              }
                            ],
                            class: {
                              textAreaRedTip:
                                _vm.verifyStatus && _vm.selectRejectText === ""
                            },
                            attrs: {
                              maxlength: "50",
                              placeholder: "请输入原因"
                            },
                            domProps: { value: _vm.selectRejectText },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.selectRejectText = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.selectRejectIds.includes("other") &&
                          _vm.verifyStatus &&
                          _vm.selectRejectText === ""
                            ? _c("div", { staticClass: "null_value_tip" }, [
                                _vm._v("值不能为空\n            ")
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "pop_ops" }, [
                        _c(
                          "div",
                          {
                            staticClass: "cancle",
                            on: {
                              click: function($event) {
                                _vm.setPops[
                                  _vm.dragType + appfileItem.specialAppfile
                                ] = false
                              }
                            }
                          },
                          [_vm._v("取消")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "submit",
                            on: {
                              click: function($event) {
                                return _vm.setAppfile(appfileIndex)
                              }
                            }
                          },
                          [_vm._v("确定")]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "op_set",
                          attrs: { slot: "reference" },
                          slot: "reference"
                        },
                        [
                          _c("i", {
                            staticClass: "kdfont kdfont-chakanjichuziliao"
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "bottom",
                        width: "196",
                        "popper-class": "delete_pop"
                      },
                      model: {
                        value:
                          _vm.deletePops[
                            _vm.dragType + appfileItem.specialAppfile
                          ],
                        callback: function($$v) {
                          _vm.$set(
                            _vm.deletePops,
                            _vm.dragType + appfileItem.specialAppfile,
                            $$v
                          )
                        },
                        expression:
                          "deletePops[dragType + appfileItem.specialAppfile]"
                      }
                    },
                    [
                      _c("p", [_vm._v("移除后将取消候选人的面试，确认移除？")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pop_ops" }, [
                        _c(
                          "div",
                          {
                            staticClass: "cancle",
                            on: {
                              click: function($event) {
                                _vm.deletePops[
                                  _vm.dragType + appfileItem.specialAppfile
                                ] = false
                              }
                            }
                          },
                          [_vm._v("取消")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "submit",
                            on: {
                              click: function($event) {
                                return _vm.deleteAppfile(appfileIndex)
                              }
                            }
                          },
                          [_vm._v("确定")]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "op_delete",
                          attrs: { slot: "reference" },
                          slot: "reference"
                        },
                        [_c("span")]
                      )
                    ]
                  )
                ],
                1
              )
            }),
            0
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }